import { Box, Button, Flex, Img } from "@chakra-ui/react"
import React from "react"
import { FALLBACKIMAGES } from "../../common/commonConstants"
import { chakraTheme } from "../../theme/chakraTheme"
import { Heading2CapsSubText } from "./heading2CapsSubText"

interface productThumbnailType3Props {
  bg?: string
  subText: string
  buttonText?: string
  heading?: string
  onClickCallBack?: (e: React.MouseEvent) => void
}

const fallBackImage = FALLBACKIMAGES["150x150"]

export const ProductThumbnailType3 = ({
  bg,
  subText,
  heading = "Blanks",
  buttonText = "Select",
  onClickCallBack
}: productThumbnailType3Props): JSX.Element => (
  <Box maxW={["284px"]} m="1" sx={{ boxShadow: "0px 6px 20px 0px rgba(0, 0, 0, 0.25);" }} borderRadius={"10px"} px="3">
    <Box cursor={"pointer"} bg={["white"]} px="0" py="0px" margin="auto">
      <Heading2CapsSubText
        headingText={heading}
        subText={subText}
        headingTextStyles={{ width: ["100%"], borderBottomWidth: "2px" }}
        subTextStyles={{ mb: "10px" }}
      />
      <Box>
        <Box
          w="100%"
          boxSize="borderBox"
          h="180px"
          borderWidth={"1px"}
          borderColor="white"
          bg={bg ? undefined : chakraTheme.colors.imageFallBackBackground}
          background={bg ? `url(${bg}) no-repeat 50% 50%` : undefined}
          backgroundSize={bg ? "cover" : undefined}
          display={bg ? undefined : "flex"}
          alignItems={bg ? undefined : "center"}
          justifyContent={bg ? undefined : "center"}
          alignContent={"center"}
          onClick={onClickCallBack}
        >
          {!bg && <Img src={fallBackImage} alt="Product placeholder" height="100%" width="100%" objectFit="contain" />}
        </Box>
        <Flex mt="12px" mb="12px" borderRadius={"10px"}>
          <Button shadow={"none"} margin="auto" variant="Button1RegularOutline" border="1px solid" borderColor={"primary"} onClick={onClickCallBack}>
            {buttonText}
          </Button>
        </Flex>
      </Box>
    </Box>
  </Box>
)
